import { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import api from "@/api/api.js";

const safe = (v) => (v === null || v === undefined || v === "" ? "—" : v);

const CompanyOwnerCard = ({ userId }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    let active = true;
    setLoading(true);
    api
      .get(`/users/${userId}`)
      .then(({ data }) => active && setUser(data))
      .catch(() => active && setUser(null))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [userId]);

  if (!userId) return null;

  return (
    <Card className="mt-3">
      <Card.Header className="fw-bold">Creada por</Card.Header>
      <Card.Body>
        {loading ? (
          <div className="d-flex align-items-center gap-2">
            <Spinner animation="border" size="sm" />
            <span>Cargando...</span>
          </div>
        ) : !user ? (
          <span className="text-muted">No disponible.</span>
        ) : (
          <>
            <div>
              <strong>Nombre:</strong>{" "}
              {safe(
                `${user.userProfile?.name ?? ""} ${user.userProfile?.lastname ?? ""}`.trim(),
              )}
            </div>
            <div>
              <strong>Email:</strong> {safe(user.username)}
            </div>
            <div>
              <strong>Tipo:</strong> {safe(user.userProfile?.userType)}
            </div>
            <Link
              to={`/client-users/${userId}/show`}
              className="btn btn-outline-primary btn-sm mt-2"
            >
              <i className="bi bi-person-lines-fill me-1" />
              Ver usuario y sus emisores
            </Link>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default CompanyOwnerCard;
